import { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import RequestTransport from "@/pages/RequestTransport";
import CarrierSignup from "@/pages/CarrierSignup";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <div className="App grain min-h-screen">
            <BrowserRouter>
                <Navbar />
                <main className="relative z-10">
                    <Suspense fallback={<div />}>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/services" element={<Services />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route
                                path="/request-transport"
                                element={<RequestTransport />}
                            />
                            <Route
                                path="/carrier-signup"
                                element={<CarrierSignup />}
                            />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </Suspense>
                </main>
                <Footer />
                <Toaster
                    theme="light"
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: "#ffffff",
                            border: "1px solid rgba(0,224,187,0.4)",
                            color: "#1a1a1a",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}

export default App;
